/**
 * Constants for Projects page component
 */

export const REGION_OPTIONS = [
  { value: 'NER', label: 'NER' },
  { value: 'NR', label: 'NR' },
  { value: 'WR', label: 'WR' },
  { value: 'SR', label: 'SR' },
  { value: 'ER', label: 'ER' },
];

export const STATUS_OPTIONS = ['Active', 'On Hold', 'Completed', 'Cancelled'];

export const DEFAULT_FORM_DATA = {
  name: '',
  code: '',
  region: '',
  description: '',
  status: 'Active',
  start_date: '',
  end_date: '',
};

export const STATUS_COLOR_MAP = {
  'Active': 'success',
  'On Hold': 'warning',
  'Completed': 'info',
  'Cancelled': 'error',
};
